import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Icon } from '@calendly/ui/components/icon';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { colorIconInfo } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c10z6h1u";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ol';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const pillButtonCss = "p16vp1lx";
const PillButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(pillButtonCss, props.className)} />);
const pillIconCss = "p1xumbvb";
const PillIcon = forwardRef((props, ref) => <Icon ref={ref} {...props} className={classNames(pillIconCss, props.className)} />);
const controlExpandedCss = "cjrqbup";
const controlCss = "c1t1y09c";
const Control = forwardRef((props, ref) => {
  const {
    expanded,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(controlCss, {
    [controlExpandedCss]: expanded
  }, props.className)} />;
});
const controlButtonCss = "c164gnox";
const ControlButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(controlButtonCss, props.className)} />);
export const Pills = ({
  items,
  onClick = () => {}
}) => <Container>
    {items.map(item => <li key={item.uri}>
        <PillButton onClick={() => {
      onClick(item);
    }}>
          {item.name}
          <PillIcon name="delete" />
        </PillButton>
      </li>)}
  </Container>;
export const PillControl = ({
  children,
  expanded,
  onClick,
  ...restProps
}) => <Control expanded={expanded} {...restProps}>
    {children}
    <ControlButton onClick={onClick} aria-label={expanded ? I18n.t('publisher.organization.reporting.filters.hide') : I18n.t('publisher.organization.reporting.filters.show')}>
      {expanded ? <ArrowChevronUpMiniIcon color={colorIconInfo} /> : <ArrowChevronDownMiniIcon color={colorIconInfo} />}
    </ControlButton>
  </Control>;

require("./pills.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pills.js");